// extracted by mini-css-extract-plugin
export default {"productDescription":"Kca-z","featuredDescription":"Lca-z","description":"Mca-z","more":"Nca-z","descriptionSku":"Oca-z"};